import { pt_br } from './translations/pt_br';
import { en_us } from './translations/en_us';

const msg = {
  pt_br,
  en_us
};

export var messages = msg;
